export interface NavigationItem {
  id: string;
  type: 'item' | 'group' | 'collapsable' | 'button';
  translate?: string;
  icon?: string;
  hidden?: boolean;
  url?: string;
  classes?: string;
  items: NavigationItem[];
  expanded?: boolean;
}

export function newNavigationItem(item?: Partial<NavigationItem>): NavigationItem {
  return {
    id: '',
    type: 'item',
    translate: undefined,
    icon: undefined,
    hidden: undefined,
    url: undefined,
    classes: undefined,
    items: [],
    expanded: false,
    ...item,
  };
}
